import React, { useEffect, useState } from "react";
import { 
  FaBullhorn, FaAd, FaSearch, FaPalette, 
  FaFileAlt, FaChartLine, FaCogs, FaHeadset,
  FaArrowLeft, FaCheckCircle, FaTachometerAlt,
  FaDatabase, FaUserTie, FaClock, FaVideo, FaRobot,
  FaChartBar, FaPenFancy, FaInstagram, FaFacebook, 
  FaGoogle, FaLinkedin, FaTwitter, FaEnvelope,
  FaShieldAlt, FaUsers, FaLightbulb, FaRocket,
  FaLaptopCode, FaFilm, FaMobileAlt, FaCloudUploadAlt
} from "react-icons/fa";

// ✅ استيراد الصورة من مجلد assets
import whatsappBotImage from "../assets/robot.png";

const Services = () => {
  // Language state
  const [lang, setLang] = useState("ar"); // 'ar' or 'en'

  // Hero Slider Images
  const images = [
    "https://images.unsplash.com/photo-1557804506-669a67965ba0?q=80&w=1600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=1600&auto=format&fit=crop",
  ];
  
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);

  // WhatsApp number
  const whatsappNumber = "201037334294";

  // Function to open WhatsApp with a custom message
  const handleWhatsApp = (message) => {
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${whatsappNumber}?text=${encodedMessage}`, "_blank");
  };

  // Translations object
  const translations = {
    // Hero section
    hero: {
      ar: {
        title: "خدماتنا التسويقية المتكاملة",
        subtitle: "نقدم حلولاً تسويقية متطورة للشركات والعلامات التجارية، تجمع بين الإبداع والتكنولوجيا الحديثة لتحقيق أفضل النتائج وزيادة المبيعات",
        btnOrder: "اطلب الخدمة الآن",
        btnLearn: "تعرف على خدماتنا"
      },
      en: {
        title: "Our Integrated Marketing Services",
        subtitle: "We provide advanced marketing solutions for businesses and brands, combining creativity with modern technology to achieve the best results and increase sales",
        btnOrder: "Order Service Now",
        btnLearn: "Learn About Our Services"
      }
    },

    // Section headers
    sectionHeaders: {
      ar: {
        servicesTitle: "خدماتنا المميزة",
        servicesSubtitle: "نقدم مجموعة متكاملة من الحلول التسويقية المتطورة لتلبية احتياجات الشركات والعلامات التجارية",
        whyTitle: "لماذا تختار خدماتنا؟",
        whySubtitle: "نتميز بتقديم حلول متكاملة تجمع بين الخبرة التسويقية والفهم العميق لاحتياجات السوق",
        ctaTitle: "جاهز لتطوير علامتك التجارية؟",
        ctaSubtitle: "تواصل معنا الآن للحصول على استشارة مجانية وابدأ رحلة النمو التسويقي",
        ctaBtn: "احصل على استشارة مجانية"
      },
      en: {
        servicesTitle: "Our Featured Services",
        servicesSubtitle: "We offer a comprehensive set of advanced marketing solutions to meet the needs of businesses and brands",
        whyTitle: "Why Choose Our Services?",
        whySubtitle: "We stand out by providing integrated solutions that combine marketing expertise with deep understanding of market needs",
        ctaTitle: "Ready to Develop Your Brand?",
        ctaSubtitle: "Contact us now for a free consultation and start your marketing growth journey",
        ctaBtn: "Get a Free Consultation"
      }
    },

    // Service categories data (translated)
    serviceCategories: {
      ar: [
        {
          title: "إدارة وسائل التواصل الاجتماعي",
          description: "إدارة احترافية لحساباتك على جميع منصات التواصل",
          tags: ["سوشيال ميديا", "محتوى", "تفاعل"],
          features: [
            { text: "إدارة حسابات فيسبوك وإنستجرام", icon: <FaFacebook /> },
            { text: "إنشاء محتوى إبداعي يومي", icon: <FaPenFancy /> },
            { text: "الرد على التعليقات والرسائل", icon: <FaHeadset /> },
            { text: "تحليل الأداء والتفاعل", icon: <FaChartLine /> }
          ],
          stats: [
            { number: "500+", label: "حساب مُدار" },
            { number: "1M+", label: "متابع نشط" }
          ]
        },
        {
          title: "الإعلانات المدفوعة",
          description: "حملات إعلانية مستهدفة بعائد استثمار عالي",
          tags: ["إعلانات", "Facebook Ads", "Google Ads"],
          features: [
            { text: "إعلانات فيسبوك وإنستجرام", icon: <FaFacebook /> },
            { text: "إعلانات جوجل المدفوعة", icon: <FaGoogle /> },
            { text: "استهداف دقيق للجمهور", icon: <FaUsers /> },
            { text: "تحسين الحملات باستمرار", icon: <FaTachometerAlt /> }
          ],
          stats: [
            { number: "800+", label: "حملة ناجحة" },
            { number: "600%", label: "متوسط ROI" }
          ]
        },
        {
          title: "تحسين محركات البحث SEO",
          description: "تصدر نتائج البحث وزيادة الزيارات العضوية",
          tags: ["SEO", "محركات البحث", "ترافيك"],
          features: [
            { text: "تحسين محتوى الموقع", icon: <FaSearch /> },
            { text: "بناء روابط خارجية قوية", icon: <FaDatabase /> },
            { text: "تحليل الكلمات المفتاحية", icon: <FaLightbulb /> },
            { text: "تقارير أداء شهرية", icon: <FaChartBar /> }
          ],
          stats: [
            { number: "300+", label: "موقع محسّن" },
            { number: "400%", label: "زيادة الزيارات" }
          ]
        },
        {
          title: "تصميم الهوية التجارية",
          description: "تصميم هوية بصرية متكاملة لعلامتك التجارية",
          tags: ["براندنج", "شعار", "هوية بصرية"],
          features: [
            { text: "تصميم شعار احترافي", icon: <FaPalette /> },
            { text: "دليل الهوية البصرية", icon: <FaFileAlt /> },
            { text: "تصميم بطاقات العمل", icon: <FaUserTie /> },
            { text: "تصميم المطبوعات", icon: <FaPenFancy /> }
          ],
          stats: [
            { number: "400+", label: "هوية مصممة" },
            { number: "99%", label: "رضا العملاء" }
          ]
        },
        {
          title: "تصميم جرافيك",
          description: "تصاميم جرافيك احترافية للمنشورات والإعلانات",
          tags: ["جرافيك", "تصميم", "منشورات"],
          features: [
            { text: "تصميم منشورات سوشيال ميديا", icon: <FaInstagram /> },
            { text: "تصميم إعلانات رقمية", icon: <FaAd /> },
            { text: "تصميم انفوجرافيك", icon: <FaChartBar /> },
            { text: "تصميم بنرات إعلانية", icon: <FaBullhorn /> }
          ],
          stats: [
            { number: "2000+", label: "تصميم منفذ" },
            { number: "4.9", label: "تقييم العملاء" }
          ]
        },
        {
          title: "موشن جرافيك وفيديو",
          description: "فيديوهات موشن جرافيك احترافية لعلامتك التجارية",
          tags: ["موشن", "فيديو", "رسوم متحركة"],
          features: [
            { text: "فيديوهات تعريفية للشركات", icon: <FaVideo /> },
            { text: "موشن جرافيك إعلاني", icon: <FaRocket /> },
            { text: "فيديوهات سوشيال ميديا", icon: <FaInstagram /> },
            { text: "رسوم متحركة احترافية", icon: <FaPalette /> }
          ],
          stats: [
            { number: "500+", label: "فيديو منفذ" },
            { number: "5M+", label: "مشاهدة" }
          ]
        },
        {
          title: "التسويق بالمحتوى",
          description: "محتوى إبداعي يجذب العملاء ويزيد المبيعات",
          tags: ["محتوى", "كتابة", "مقالات"],
          features: [
            { text: "كتابة مقالات تسويقية", icon: <FaPenFancy /> },
            { text: "محتوى سوشيال ميديا", icon: <FaInstagram /> },
            { text: "كتابة إعلانات جذابة", icon: <FaBullhorn /> },
            { text: "استراتيجية محتوى شاملة", icon: <FaLightbulb /> }
          ],
          stats: [
            { number: "1000+", label: "مقال منشور" },
            { number: "300%", label: "زيادة التفاعل" }
          ]
        },
        {
          title: "التسويق بالبريد الإلكتروني",
          description: "حملات بريد إلكتروني فعالة لزيادة المبيعات",
          tags: ["إيميل", "نشرات", "حملات"],
          features: [
            { text: "تصميم قوالب بريد احترافية", icon: <FaEnvelope /> },
            { text: "إدارة قوائم البريد", icon: <FaDatabase /> },
            { text: "حملات بريد مستهدفة", icon: <FaUsers /> },
            { text: "تحليل معدلات الفتح", icon: <FaChartLine /> }
          ],
          stats: [
            { number: "600+", label: "حملة بريد" },
            { number: "45%", label: "معدل فتح" }
          ]
        },
        {
          title: "تحليلات التسويق",
          description: "تقارير تحليلية دقيقة لقياس أداء حملاتك",
          tags: ["تحليلات", "تقارير", "بيانات"],
          features: [
            { text: "تحليل أداء الحملات", icon: <FaChartLine /> },
            { text: "تقارير شهرية مفصلة", icon: <FaFileAlt /> },
            { text: "تتبع التحويلات", icon: <FaTachometerAlt /> },
            { text: "توصيات للتحسين", icon: <FaLightbulb /> }
          ],
          stats: [
            { number: "400+", label: "تقرير شهري" },
            { number: "98%", label: "دقة البيانات" }
          ]
        },
        {
          title: "استراتيجيات التسويق",
          description: "خطط تسويقية شاملة لنمو علامتك التجارية",
          tags: ["استراتيجية", "تخطيط", "نمو"],
          features: [
            { text: "دراسة السوق والمنافسين", icon: <FaSearch /> },
            { text: "وضع خطة تسويقية شاملة", icon: <FaLightbulb /> },
            { text: "تحديد الجمهور المستهدف", icon: <FaUsers /> },
            { text: "متابعة تنفيذ الخطة", icon: <FaCogs /> }
          ],
          stats: [
            { number: "200+", label: "استراتيجية" },
            { number: "250%", label: "نمو متوسط" }
          ]
        },
        {
          title: "إدارة الحملات الإعلانية",
          description: "إدارة شاملة لجميع حملاتك الإعلانية",
          tags: ["حملات", "إدارة", "تحسين"],
          features: [
            { text: "إدارة حملات متعددة المنصات", icon: <FaCogs /> },
            { text: "تحسين الميزانية الإعلانية", icon: <FaChartLine /> },
            { text: "اختبار A/B للإعلانات", icon: <FaTachometerAlt /> },
            { text: "تقارير أداء يومية", icon: <FaFileAlt /> }
          ],
          stats: [
            { number: "1000+", label: "حملة مُدارة" },
            { number: "500%", label: "عائد استثمار" }
          ]
        },
        {
          title: "التسويق بالمؤثرين",
          description: "حملات تسويقية مع المؤثرين لزيادة الوعي بعلامتك",
          tags: ["مؤثرين", "تعاون", "وعي"],
          features: [
            { text: "اختيار المؤثرين المناسبين", icon: <FaUsers /> },
            { text: "إدارة التعاون والعقود", icon: <FaFileAlt /> },
            { text: "متابعة أداء الحملات", icon: <FaChartLine /> },
            { text: "قياس العائد على الاستثمار", icon: <FaTachometerAlt /> }
          ],
          stats: [
            { number: "300+", label: "حملة مؤثرين" },
            { number: "10M+", label: "وصول إجمالي" }
          ]
        }
      ],
      en: [
        {
          title: "Social Media Management",
          description: "Professional management of your accounts across all platforms",
          tags: ["Social Media", "Content", "Engagement"],
          features: [
            { text: "Facebook & Instagram Management", icon: <FaFacebook /> },
            { text: "Daily Creative Content Creation", icon: <FaPenFancy /> },
            { text: "Comments & Messages Response", icon: <FaHeadset /> },
            { text: "Performance & Engagement Analysis", icon: <FaChartLine /> }
          ],
          stats: [
            { number: "500+", label: "Managed Accounts" },
            { number: "1M+", label: "Active Followers" }
          ]
        },
        {
          title: "Paid Advertising",
          description: "Targeted ad campaigns with high ROI",
          tags: ["Ads", "Facebook Ads", "Google Ads"],
          features: [
            { text: "Facebook & Instagram Ads", icon: <FaFacebook /> },
            { text: "Google Paid Advertising", icon: <FaGoogle /> },
            { text: "Precise Audience Targeting", icon: <FaUsers /> },
            { text: "Continuous Campaign Optimization", icon: <FaTachometerAlt /> }
          ],
          stats: [
            { number: "800+", label: "Successful Campaigns" },
            { number: "600%", label: "Average ROI" }
          ]
        },
        {
          title: "SEO Optimization",
          description: "Top search rankings and increased organic traffic",
          tags: ["SEO", "Search Engines", "Traffic"],
          features: [
            { text: "Website Content Optimization", icon: <FaSearch /> },
            { text: "Strong Backlink Building", icon: <FaDatabase /> },
            { text: "Keyword Analysis", icon: <FaLightbulb /> },
            { text: "Monthly Performance Reports", icon: <FaChartBar /> }
          ],
          stats: [
            { number: "300+", label: "Optimized Sites" },
            { number: "400%", label: "Traffic Increase" }
          ]
        },
        {
          title: "Brand Identity Design",
          description: "Complete visual identity design for your brand",
          tags: ["Branding", "Logo", "Visual Identity"],
          features: [
            { text: "Professional Logo Design", icon: <FaPalette /> },
            { text: "Visual Identity Guidelines", icon: <FaFileAlt /> },
            { text: "Business Card Design", icon: <FaUserTie /> },
            { text: "Print Materials Design", icon: <FaPenFancy /> }
          ],
          stats: [
            { number: "400+", label: "Identities Designed" },
            { number: "99%", label: "Client Satisfaction" }
          ]
        },
        {
          title: "Graphic Design",
          description: "Professional graphic designs for posts and ads",
          tags: ["Graphic", "Design", "Posts"],
          features: [
            { text: "Social Media Post Design", icon: <FaInstagram /> },
            { text: "Digital Ad Design", icon: <FaAd /> },
            { text: "Infographic Design", icon: <FaChartBar /> },
            { text: "Banner Ad Design", icon: <FaBullhorn /> }
          ],
          stats: [
            { number: "2000+", label: "Designs Completed" },
            { number: "4.9", label: "Client Rating" }
          ]
        },
        {
          title: "Motion Graphics & Video",
          description: "Professional motion graphics videos for your brand",
          tags: ["Motion", "Video", "Animation"],
          features: [
            { text: "Company Intro Videos", icon: <FaVideo /> },
            { text: "Advertising Motion Graphics", icon: <FaRocket /> },
            { text: "Social Media Videos", icon: <FaInstagram /> },
            { text: "Professional Animations", icon: <FaPalette /> }
          ],
          stats: [
            { number: "500+", label: "Videos Completed" },
            { number: "5M+", label: "Total Views" }
          ]
        },
        {
          title: "Content Marketing",
          description: "Creative content that attracts customers and increases sales",
          tags: ["Content", "Writing", "Articles"],
          features: [
            { text: "Marketing Article Writing", icon: <FaPenFancy /> },
            { text: "Social Media Content", icon: <FaInstagram /> },
            { text: "Attractive Ad Copywriting", icon: <FaBullhorn /> },
            { text: "Comprehensive Content Strategy", icon: <FaLightbulb /> }
          ],
          stats: [
            { number: "1000+", label: "Published Articles" },
            { number: "300%", label: "Engagement Increase" }
          ]
        },
        {
          title: "Email Marketing",
          description: "Effective email campaigns to increase sales",
          tags: ["Email", "Newsletters", "Campaigns"],
          features: [
            { text: "Professional Email Template Design", icon: <FaEnvelope /> },
            { text: "Email List Management", icon: <FaDatabase /> },
            { text: "Targeted Email Campaigns", icon: <FaUsers /> },
            { text: "Open Rate Analysis", icon: <FaChartLine /> }
          ],
          stats: [
            { number: "600+", label: "Email Campaigns" },
            { number: "45%", label: "Open Rate" }
          ]
        },
        {
          title: "Marketing Analytics",
          description: "Accurate analytical reports to measure campaign performance",
          tags: ["Analytics", "Reports", "Data"],
          features: [
            { text: "Campaign Performance Analysis", icon: <FaChartLine /> },
            { text: "Detailed Monthly Reports", icon: <FaFileAlt /> },
            { text: "Conversion Tracking", icon: <FaTachometerAlt /> },
            { text: "Improvement Recommendations", icon: <FaLightbulb /> }
          ],
          stats: [
            { number: "400+", label: "Monthly Reports" },
            { number: "98%", label: "Data Accuracy" }
          ]
        },
        {
          title: "Marketing Strategies",
          description: "Comprehensive marketing plans for brand growth",
          tags: ["Strategy", "Planning", "Growth"],
          features: [
            { text: "Market & Competitor Research", icon: <FaSearch /> },
            { text: "Comprehensive Marketing Plan", icon: <FaLightbulb /> },
            { text: "Target Audience Definition", icon: <FaUsers /> },
            { text: "Plan Implementation Monitoring", icon: <FaCogs /> }
          ],
          stats: [
            { number: "200+", label: "Strategies" },
            { number: "250%", label: "Average Growth" }
          ]
        },
        {
          title: "Campaign Management",
          description: "Comprehensive management of all your advertising campaigns",
          tags: ["Campaigns", "Management", "Optimization"],
          features: [
            { text: "Multi-Platform Campaign Management", icon: <FaCogs /> },
            { text: "Ad Budget Optimization", icon: <FaChartLine /> },
            { text: "A/B Testing for Ads", icon: <FaTachometerAlt /> },
            { text: "Daily Performance Reports", icon: <FaFileAlt /> }
          ],
          stats: [
            { number: "1000+", label: "Managed Campaigns" },
            { number: "500%", label: "ROI" }
          ]
        },
        {
          title: "Influencer Marketing",
          description: "Marketing campaigns with influencers to increase brand awareness",
          tags: ["Influencers", "Collaboration", "Awareness"],
          features: [
            { text: "Selecting Suitable Influencers", icon: <FaUsers /> },
            { text: "Collaboration & Contract Management", icon: <FaFileAlt /> },
            { text: "Campaign Performance Monitoring", icon: <FaChartLine /> },
            { text: "ROI Measurement", icon: <FaTachometerAlt /> }
          ],
          stats: [
            { number: "300+", label: "Influencer Campaigns" },
            { number: "10M+", label: "Total Reach" }
          ]
        }
      ]
    },

    // Additional features
    additionalFeatures: {
      ar: [
        {
          title: "دعم فني على مدار الساعة",
          description: "فريق دعم متخصص جاهز للإجابة على استفساراتك 24/7",
          icon: <FaHeadset />,
          color: "#ff6b35"
        },
        {
          title: "استراتيجيات مخصصة",
          description: "خطط تسويقية مصممة خصيصاً لتناسب احتياجات عملك",
          icon: <FaLightbulb />,
          color: "#ff6b35"
        },
        {
          title: "تقارير وتحليلات متقدمة",
          description: "تقارير تفصيلية لقياس أداء حملاتك وتحسين النتائج",
          icon: <FaChartLine />,
          color: "#ff6b35"
        },
        {
          title: "فريق محترف ومبدع",
          description: "فريق من المسوقين والمصممين ذوي الخبرة الواسعة",
          icon: <FaUsers />,
          color: "#ff6b35"
        }
      ],
      en: [
        {
          title: "24/7 Technical Support",
          description: "Dedicated support team ready to answer your inquiries around the clock",
          icon: <FaHeadset />,
          color: "#ff6b35"
        },
        {
          title: "Custom Strategies",
          description: "Marketing plans designed specifically to suit your business needs",
          icon: <FaLightbulb />,
          color: "#ff6b35"
        },
        {
          title: "Advanced Reports & Analytics",
          description: "Detailed reports to measure campaign performance and improve results",
          icon: <FaChartLine />,
          color: "#ff6b35"
        },
        {
          title: "Professional & Creative Team",
          description: "Team of experienced marketers and designers",
          icon: <FaUsers />,
          color: "#ff6b35"
        }
      ]
    },

    // WhatsApp tooltip
    whatsappTooltip: {
      ar: "تواصل مع بوت المساعدة 📲",
      en: "Contact Support Bot 📲"
    },

    // Button text in service cards
    orderButton: {
      ar: "اطلب الخدمة",
      en: "Order Service"
    },

    // Features section header for service card
    featuresHeader: {
      ar: "المميزات",
      en: "Features"
    }
  };

  // Get current language data
  const currentLang = lang;

  // Helper to get translated service categories
  const getServiceCategories = () => {
    return translations.serviceCategories[currentLang].map((cat, idx) => ({
      ...cat,
      id: idx + 1,
      icon: getIconForIndex(idx),
      color: "#ff6b35"
    }));
  };

  // Map icons to match original order
  const getIconForIndex = (idx) => {
    const icons = [
      <FaLaptopCode />,
      <FaDatabase />,
      <FaRobot />,
      <FaPalette />,
      <FaPalette />,
      <FaFilm />,
      <FaTachometerAlt />,
      <FaBullhorn />,
      <FaVideo />,
      <FaMobileAlt />,
      <FaCloudUploadAlt />,
      <FaChartLine />
    ];
    return icons[idx % icons.length];
  };

  const serviceCategories = getServiceCategories();
  const additionalFeatures = translations.additionalFeatures[currentLang];

  // Language switcher component
  const LangSwitcher = () => (
    <button
      onClick={() => setLang(lang === "ar" ? "en" : "ar")}
      style={{
        position: "fixed",
        top: "80px",
        right: "15px",
        zIndex: 800,
        background: "#ff6b35",
        color: "white",
        border: "none",
        borderRadius: "40px",
        padding: "8px 16px",
        fontWeight: "bold",
        cursor: "pointer",
        transition: "all 0.3s ease",
        fontFamily: "inherit",
        boxShadow: "0 2px 8px rgba(0,0,0,0.2)"
      }}
    >
      {lang === "ar" ? "English" : "العربية"}
    </button>
  );

  return (
    <div dir={lang === "ar" ? "rtl" : "ltr"}>
      {/* LangSwitcher Removed */}

      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        /* WhatsApp Button - تم التعديل لاستخدام الصورة */
        .whatsapp-float {
          position: fixed;
          bottom: 30px;
          right: 30px;
          z-index: 1000;
          color: white;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s;
          animation: pulse 2s infinite;
        }
        
        .whatsapp-float:hover {
          transform: scale(1.1);
        }
        
        .whatsapp-tooltip {
          position: absolute;
          bottom: 70px;
          right: 0;
          background-color: #000;
          color: #25D366;
          padding: 5px 10px;
          border-radius: 20px;
          font-size: 12px;
          white-space: nowrap;
          opacity: 0;
          transition: opacity 0.3s;
          pointer-events: none;
        }
        
        .whatsapp-float:hover .whatsapp-tooltip {
          opacity: 1;
        }
        
        @keyframes pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(255, 107, 53, 0.7);
          }
          70% {
            box-shadow: 0 0 0 15px rgba(255, 107, 53, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(255, 107, 53, 0);
          }
        }

        /* Hero Section */
        .hero-section {
          position: relative;
          height: 85vh;
          overflow: hidden;
        }
        
        .hero-slider {
          position: relative;
          width: 100%;
          height: 100%;
        }
        
        .hero-slider img {
          position: absolute;
          width: 100%;
          height: 100%;
          object-fit: cover;
          opacity: 0;
          transition: opacity 1.5s ease-in-out;
          top: 0;
          left: 0;
        }
        
        .hero-slider img.active {
          opacity: 1;
        }
        
        .hero-section::after {
          content: "";
          position: absolute;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, rgba(26, 27, 27, 0.34), rgba(36, 39, 41, 0.42));
          top: 0;
          left: 0;
          z-index: 1;
        }
        
        .hero-overlay {
          position: absolute;
          top: 50%;
          left: 10%;
          transform: translateY(-50%);
          color: white;
          max-width: 600px;
          z-index: 2;
          animation: fadeInUp 0.8s ease;
        }
        
        .hero-overlay h1 {
          font-size: 52px;
          font-weight: 800;
          margin-bottom: 20px;
          line-height: 1.2;
        }
        
        .hero-overlay h1 span {
          background: linear-gradient(135deg, #FCFDFD, #DCE9EE);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }
        
        .hero-overlay p {
          font-size: 18px;
          margin-bottom: 30px;
          line-height: 1.6;
          opacity: 0.95;
        }
        
        .hero-buttons {
          display: flex;
          gap: 20px;
          flex-wrap: wrap;
        }
        
        .btn-primary {
          background: linear-gradient(135deg, #ff6b35, #f7931e);
          border: none;
          padding: 12px 32px;
          color: white;
          border-radius: 50px;
          cursor: pointer;
          font-weight: 600;
          font-size: 15px;
          transition: all 0.3s;
          box-shadow: 0 4px 15px rgba(14, 116, 171, 0.3);
        }
        
        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(14, 116, 171, 0.4);
        }
        
        .btn-secondary {
          background: transparent;
          border: 2px solid white;
          padding: 12px 32px;
          color: white;
          border-radius: 50px;
          cursor: pointer;
          font-weight: 600;
          font-size: 15px;
          transition: all 0.3s;
        }
        
        .btn-secondary:hover {
          background: rgba(255,255,255,0.1);
          border-color: #ff6b35;
        }

        /* Services Section */
        .services-section {
          padding: 4rem 2rem;
          background: var(--bg-color);
          direction: rtl;
        }
        
        .section-header {
          text-align: center;
          margin-bottom: 2.5rem;
        }
        
        .section-title {
          font-size: 2.2rem;
          font-weight: 800;
          background: linear-gradient(135deg, #ff6b35, #f7931e);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          margin-bottom: 0.8rem;
        }
        
        .section-subtitle {
          font-size: 0.9rem;
          color: var(--text-secondary);
          max-width: 600px;
          margin: 0 auto;
        }
        
        .services-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
          gap: 1.5rem;
          max-width: 1400px;
          margin: 0 auto;
        }
        
        .service-card {
          background: var(--card-bg);
          border: 1px solid var(--border-color);
          border-radius: 1rem;
          overflow: hidden;
          transition: all 0.3s;
          cursor: pointer;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
        }
        
        .service-card:hover {
          transform: translateY(-5px);
          border-color: var(--primary);
          box-shadow: 0 10px 25px rgba(255, 107, 53, 0.15);
        }
        
        .service-header {
          background: var(--bg-secondary);
          padding: 1rem;
          text-align: center;
          border-bottom: 1px solid var(--border-color);
        }
        
        .service-icon {
          width: 55px;
          height: 55px;
          background: linear-gradient(135deg, #ff6b35, #f7931e);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 0.6rem;
          font-size: 1.6rem;
          color: white;
        }
        
        .service-title {
          font-size: 1.2rem;
          font-weight: 700;
          color: var(--text-color);
          margin-bottom: 0.4rem;
        }
        
        .service-description {
          font-size: 0.8rem;
          color: var(--text-secondary);
          line-height: 1.4;
        }
        
        .service-tags {
          display: flex;
          justify-content: center;
          gap: 0.4rem;
          margin-top: 0.8rem;
          flex-wrap: wrap;
        }
        
        .service-tag {
          background: rgba(255, 107, 53, 0.1);
          padding: 0.15rem 0.6rem;
          border-radius: 50px;
          font-size: 0.6rem;
          color: var(--primary);
          font-weight: 600;
        }
        
        .service-content {
          padding: 1rem;
        }
        
        .features-list {
          margin-bottom: 1rem;
        }
        
        .features-title {
          font-size: 0.8rem;
          font-weight: 700;
          color: var(--text-color);
          margin-bottom: 0.6rem;
          display: flex;
          align-items: center;
          gap: 0.4rem;
        }
        
        .feature-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          margin-bottom: 0.4rem;
          color: var(--text-secondary);
          font-size: 0.7rem;
        }
        
        .feature-item svg {
          color: var(--primary);
          font-size: 0.7rem;
        }
        
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 0.8rem;
          margin-bottom: 1rem;
          padding: 0.6rem 0;
          border-top: 1px solid var(--border-color);
          border-bottom: 1px solid var(--border-color);
        }
        
        .stat-item {
          text-align: center;
        }
        
        .stat-number {
          font-size: 1rem;
          font-weight: 800;
          background: linear-gradient(135deg, #ff6b35, #f7931e);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }
        
        .stat-label {
          font-size: 0.6rem;
          color: var(--text-secondary);
          margin-top: 0.2rem;
        }
        
        .service-btn {
          width: 100%;
          background: linear-gradient(135deg, #ff6b35, #f7931e);
          border: none;
          padding: 0.6rem;
          border-radius: 50px;
          color: white;
          font-weight: 600;
          font-size: 0.8rem;
          cursor: pointer;
          transition: all 0.3s;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.4rem;
        }
        
        .service-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(255, 107, 53, 0.3);
          gap: 0.6rem;
        }
        
        /* Additional Features Section */
        .features-section {
          padding: 3rem 2rem;
          background: var(--bg-secondary);
          direction: rtl;
          border-top: 1px solid var(--border-color);
        }
        
        .features-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 1.5rem;
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .feature-card {
          background: var(--card-bg);
          border: 1px solid var(--border-color);
          border-radius: 1rem;
          padding: 1.2rem;
          text-align: center;
          transition: all 0.3s;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
        }
        
        .feature-card:hover {
          transform: translateY(-3px);
          border-color: var(--primary);
          box-shadow: 0 8px 20px rgba(255, 107, 53, 0.1);
        }
        
        .feature-icon {
          width: 50px;
          height: 50px;
          background: linear-gradient(135deg, #ff6b35, #f7931e);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 0.8rem;
          font-size: 1.3rem;
          color: white;
        }
        
        .feature-card h3 {
          font-size: 1rem;
          font-weight: 700;
          color: var(--text-color);
          margin-bottom: 0.4rem;
        }
        
        .feature-card p {
          font-size: 0.75rem;
          color: var(--text-secondary);
          line-height: 1.4;
        }
        
        /* CTA Section */
        .cta-section {
          padding: 3rem 2rem;
          background: var(--bg-color);
          text-align: center;
          direction: rtl;
          border-top: 1px solid var(--border-color);
        }
        
        .cta-content h2 {
          font-size: 1.8rem;
          font-weight: 800;
          color: var(--text-color);
          margin-bottom: 0.8rem;
        }
        
        .cta-content p {
          font-size: 0.9rem;
          color: var(--text-secondary);
          margin-bottom: 1.5rem;
          max-width: 600px;
          margin-left: auto;
          margin-right: auto;
        }
        
        .cta-btn {
          background: linear-gradient(135deg, #ff6b35, #f7931e);
          border: none;
          padding: 0.8rem 2rem;
          border-radius: 50px;
          color: white;
          font-size: 0.9rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
        }
        
        .cta-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(255, 107, 53, 0.3);
          gap: 0.8rem;
        }

        @keyframes fadeInUp { 
          from {
            opacity: 0;
            transform: translateY(30px);
          } 
          to {
            opacity: 1;
            transform: translateY(-50%);
          } 
        }

        /* Responsive */
        @media (max-width: 992px) {
          .services-grid {
            grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
            gap: 1.2rem;
          }
        }
        
        @media (max-width: 768px) {
          .hero-section {
            height: 70vh;
          }
          .hero-overlay {
            left: 5%;
            right: 5%;
            text-align: center;
            max-width: 90%;
          }
          .hero-overlay h1 {
            font-size: 32px;
          }
          .hero-overlay p {
            font-size: 14px;
          }
          .services-section,
          .features-section,
          .cta-section {
            padding: 2rem 1rem;
          }
          .section-title {
            font-size: 1.6rem;
          }
          .services-grid {
            grid-template-columns: 1fr;
          }
          .service-title {
            font-size: 1.1rem;
          }
          .cta-content h2 {
            font-size: 1.3rem;
          }
          .whatsapp-float {
            width: 50px;
            height: 50px;
            bottom: 20px;
            right: 20px;
          }
        }
        
        @media (max-width: 480px) {
          .hero-overlay h1 {
            font-size: 24px;
          }
          .btn-primary,
          .btn-secondary {
            padding: 8px 20px;
            font-size: 13px;
          }
          .whatsapp-float {
            width: 45px;
            height: 45px;
            bottom: 15px;
            right: 15px;
          }
        }
      `}</style>

      {/* ✅ زر الواتساب العائم مع الصورة بدلاً من الإيموجي */}
      <div 
        className="whatsapp-float" 
        onClick={() => handleWhatsApp("السلام عليكم، أحتاج استشارة حول الخدمات الطبية")}
      >
        <img 
          src={whatsappBotImage} 
          alt="WhatsApp Bot" 
          style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover" }} 
        />
        <div className="whatsapp-tooltip">{translations.whatsappTooltip[currentLang]}</div>
      </div>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-slider">
          {images.map((img, index) => (
            <img 
              key={index} 
              src={img} 
              alt={`Medical ${index + 1}`} 
              className={index === current ? "active" : ""} 
            />
          ))}
        </div>
        <div className="hero-overlay">
          <h1>
            {translations.hero[currentLang].title}
          </h1>
          <p>
            {translations.hero[currentLang].subtitle}
          </p>
          <div className="hero-buttons">
            {/* ربط زر "اطلب الخدمة الآن" بالواتساب */}
            <button 
              className="btn-primary"
              onClick={() => handleWhatsApp("السلام عليكم، أريد استشارة حول خدمات التسويق الرقمي")}
            >
              {translations.hero[currentLang].btnOrder}
            </button>
            {/* زر "تعرف على خدماتنا" يمكن أن يمرر إلى قسم الخدمات (اختياري) */}
            <button 
              className="btn-secondary"
              onClick={() => document.querySelector('.services-section')?.scrollIntoView({ behavior: 'smooth' })}
            >
              {translations.hero[currentLang].btnLearn}
            </button>
          </div>
        </div>
      </section>

      {/* Services Grid Section */}
      <section className="services-section">
        <div className="section-header">
          <h2 className="section-title">{translations.sectionHeaders[currentLang].servicesTitle}</h2>
          <p className="section-subtitle">{translations.sectionHeaders[currentLang].servicesSubtitle}</p>
        </div>
        <div className="services-grid">
          {serviceCategories.map((service) => (
            <div key={service.id} className="service-card">
              <div className="service-header">
                <div className="service-icon">
                  {service.icon}
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <div className="service-tags">
                  {service.tags.map((tag, idx) => (
                    <span key={idx} className="service-tag">{tag}</span>
                  ))}
                </div>
              </div>
              <div className="service-content">
                <div className="features-list">
                  <div className="features-title">
                    <FaCheckCircle /> {translations.featuresHeader[currentLang]}
                  </div>
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="feature-item">
                      {feature.icon}
                      <span>{feature.text}</span>
                    </div>
                  ))}
                </div>
                <div className="stats-grid">
                  {service.stats.map((stat, idx) => (
                    <div key={idx} className="stat-item">
                      <div className="stat-number">{stat.number}</div>
                      <div className="stat-label">{stat.label}</div>
                    </div>
                  ))}
                </div>
                {/* ربط زر "اطلب الخدمة" الخاص بكل خدمة بالواتساب مع إرسال اسم الخدمة */}
                <button 
                  className="service-btn"
                  onClick={() => handleWhatsApp(`أريد طلب خدمة: ${service.title}`)}
                >
                  {translations.orderButton[currentLang]} <FaArrowLeft />
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Additional Features Section */}
      <section className="features-section">
        <div className="section-header">
          <h2 className="section-title">{translations.sectionHeaders[currentLang].whyTitle}</h2>
          <p className="section-subtitle">{translations.sectionHeaders[currentLang].whySubtitle}</p>
        </div>
        <div className="features-grid">
          {additionalFeatures.map((feature) => (
            <div key={feature.title} className="feature-card">
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>{translations.sectionHeaders[currentLang].ctaTitle}</h2>
          <p>{translations.sectionHeaders[currentLang].ctaSubtitle}</p>
          {/* ربط زر "احصل على استشارة مجانية" بالواتساب */}
          <button 
            className="cta-btn"
            onClick={() => handleWhatsApp("السلام عليكم، أريد استشارة مجانية حول تطوير مؤسستي الطبية")}
          >
            {translations.sectionHeaders[currentLang].ctaBtn} <FaArrowLeft />
          </button>
        </div>
      </section>
    </div>
  );
};

export default Services;